import { render, staticRenderFns } from "./Notifications_Component.vue?vue&type=template&id=5c237310&"
import script from "./Notifications_Component.vue?vue&type=script&lang=js&"
export * from "./Notifications_Component.vue?vue&type=script&lang=js&"
import style0 from "./Notifications_Component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports